export default __webpack_public_path__ + "static/media/Group1333P.b2bb84e3.svg";